import React, { useEffect, useRef, useState } from 'react';
import {
  SwipeableList,
  SwipeableListItem,
  TrailingActions,
  SwipeAction,
} from 'react-swipeable-list';
import 'react-swipeable-list/dist/styles.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTrash } from '@fortawesome/free-solid-svg-icons';

const LogsList = ({ logs, onDelete }) => {
  const containerRef = useRef(null);
  const prevLogsLength = useRef(logs.length);
  const [shineEffect, setShineEffect] = useState(false);
  const [localLogs, setLocalLogs] = useState(logs);

  useEffect(() => {
    setLocalLogs(logs);
    if (logs.length > prevLogsLength.current) {
      setShineEffect(true);
      scrollToBottom();
      setTimeout(() => setShineEffect(false), 1000);
      prevLogsLength.current = logs.length;
    }
  }, [logs]);

  const scrollToBottom = () => {
    if (containerRef.current) {
      const container = containerRef.current;
      const scrollHeight = container.scrollHeight;
      const height = container.clientHeight;
      const maxScrollTop = scrollHeight - height;
      container.scrollTop = maxScrollTop > 0 ? maxScrollTop : 0;
    }
  };

  // Define trailingActions function to return the SwipeAction component
  const trailingActions = (logIndex) => (
    <TrailingActions>
      <SwipeAction
        
        onClick={() => onDelete(logIndex)}
        
      >
        <div style={{ display: 'flex', alignItems: 'center', backgroundColor: 'red', color: 'white', justifyContent: 'flex-end', alignItems: 'center', display: 'flex', padding: '0 20px',borderRadius: '10px' }}>
        <FontAwesomeIcon icon={faTrash} /> <span style={{ marginLeft: '10px' }}>Delete</span>
      </div>
      </SwipeAction>
    </TrailingActions>
  );

  const listClassName = `content-section ${shineEffect ? 'shine-animation' : ''}`;

  // Note: Custom styles applied directly to SwipeableList and SwipeableListItem via the `style` prop
  return (
    <div className={listClassName} style={{ maxHeight: '300px', overflowY: 'auto' }} ref={containerRef}>
      <div className="features-section">
       
        <SwipeableList>
        
          {localLogs.map((log, index) => (
            <SwipeableListItem
              key={index}
              trailingActions={trailingActions(index)}
              onSwipeProgress={progress => console.info(`Swipe progress: ${progress}%`)}
              // Remove inline style if you're applying all styles through classes
            >
              {/* Use the new class for swipeable list items */}
              <div className="swipeable-log-item">{log}</div>
            </SwipeableListItem>
          ))}
         
        </SwipeableList>
        
      </div>
    </div>
  );
  
};

export default LogsList;
